/**
 * 所有新接口返回的类型结构
 */

import { IPageInfo, ICursorInfo, IChunkInfo } from './pageInfo';
import { IPlainData } from './plainData';

export interface IStatus {
    status: number;
    code?: number;
}

export interface IErrorMap {
    [propName: number]: string;
}

export interface IDeleteStatus {
    code: number;
    message: IDeleteMessage;
}

export interface IDeleteMessage {
    title: string[];
    count: number;
}

export interface IResponse<T> {
    error_code: number;
    error_message: string;
    data: T;
}

export type IStatusResponse = IResponse<IStatus>;

export type IDeleteStatusResponse = IResponse<IDeleteStatus>;

export interface IList<T> {
    page_info: IPageInfo;
    list: T[];
}

export interface IListResponse<T> {
    error_code: number;
    error_message: string;
    data: IList<T>;
}

/**
 * 游标形式获取列表
 */
export interface ICursorResponse<T> {
    error_code: number;
    error_message: string;
    data: {
        list: T[];
        pagination: ICursorInfo;
    };
}

export interface IChunkList<T> {
    chunk_info: IChunkInfo;
    page_info: IPageInfo;
    list: T[];
}

export interface IChunkListResponse<T> {
    error_code: number;
    error_message: string;
    data: IChunkList<T>;
}

export interface IListResponseWidthHeader<T> extends IListResponse<T> {
    table_header?: IPlainData;
}
